import { Component, OnInit } from '@angular/core';
import { AccessUserInfo, labRangeAlertRule, UserDetail } from 'src/app/models';
import { CustomDialogService, LabManagerService, LabRequestService, UserService } from 'src/app/services';
import { LabRangeAssignComponent } from './lab-range-assign/lab-range-assign.component';
import { DialogService } from 'primeng/dynamicdialog';
import { LoaderService } from 'src/app/services/loader.service';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { SelectItem } from 'primeng';

@Component({
  selector: 'bart-lab-range-alert',
  templateUrl: './lab-range-alert.component.html',
  styleUrls: ['./lab-range-alert.component.scss'],
  providers: [DialogService, CustomDialogService]
})
export class LabRangeAlertComponent implements OnInit {
  public userInfo: UserDetail;
  tableHeader:any;
  labRangeAlertdata:labRangeAlertRule[]=[]
  labOperandList:SelectItem[]=[];
  constructor(public dialogService: CustomDialogService, private _loaderService: LoaderService,
    private _labManagerService: LabManagerService,private _userService: UserService,private _labRequestService:LabRequestService) { }

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.tableHeader = [
      { field: 'TestDisplayName', header: 'Test ID | Name', display: 'table-cell' },
      { field: 'Description', header: 'Description', display: 'table-cell'},
      { field: 'AcceptableLevel', header: 'Acceptable Level', display: 'table-cell' },
      { field: 'ActionLevel', header: 'Action Level', display: 'table-cell' },
      { field: 'UnacceptableLevel', header: 'Unacceptable Level', display: 'table-cell' },
    ];
    this.getLabRangeAlertRules();
    this.loadLabOperands();
  }
  openLabRangeAssign(rowData) {
    const ref = this.dialogService.open(LabRangeAssignComponent, {
      header: 'Assign Range',
      width: '60%',
      data: { labRangeAlertdata: rowData,labOperands:this.labOperandList }
    });
    
   
  }
  getLabRangeAlertRules(){
    this._loaderService.show();
    this._labManagerService.getLabRangeAlertRules().subscribe(response => {
      if(response){
      this.labRangeAlertdata = response.getLabRangeAlertRules;  
      this._loaderService.hide()
    }
    else{
      this._loaderService.hide()
    }
    },
      (error) => {
        this._loaderService.hide()
      });
       //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.TAB_CLICKED,
      screenName: ScreenName.LAB_MANAGER,
      screenPath: location.pathname,
      key: "LAB_RANGE_ALERTS",
      value: '',
      eventDescription:UserActionDescription.LAB_RANGE_ALERTS_GRID_LOADED
    });
    //#endregion
  }
  sortColumn(event)
  {
//#region User Action Audit
   this._userService.logUserAction({
     userName: this.userInfo.userName,
     userAction: UserAction.SORT,
     screenName: ScreenName.LAB_MANAGER,
     screenPath: location.pathname,
     key: event.field,
     value: event.order === 1 ? 'ASC' : 'DESC',
     eventDescription:UserActionDescription.LAB_RANGE_ALERTS_COLUMN_SORT
   });
   //#endregion

 }
 paginate(event) 
  {
    
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.LAB_MANAGER,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:UserActionDescription.LAB_RANGE_ALERTS_PAGE_NO_CLICKED
    });
    //#endregion
  }
  loadLabOperands()
  {
      let param =
      {
        "GETDROPDOWNBOX":
        {
          "DropDownBoxGroup": "LabOperand"
        }
      }
      this._labRequestService.getLabDropDownBox(param).subscribe((resp:any)=>{
        if(resp.length>0)
        {
          this.labOperandList = resp.map(data => ({
            label: data.DropDownBoxValue,
            value: data.DropDownBoxValue,
          }));
        }
      },
      (erro)=>
      {
      });
  }
  
}
